import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=beffe230&scoped=true&"
import script from "./MainMenu.vue?vue&type=script&lang=js&"
export * from "./MainMenu.vue?vue&type=script&lang=js&"
import style0 from "./MainMenu.vue?vue&type=style&index=0&id=beffe230&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beffe230",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jeffreymb/BibleLing/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('beffe230')) {
      api.createRecord('beffe230', component.options)
    } else {
      api.reload('beffe230', component.options)
    }
    module.hot.accept("./MainMenu.vue?vue&type=template&id=beffe230&scoped=true&", function () {
      api.rerender('beffe230', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainMenu.vue"
export default component.exports